import React from 'react';
import { Typography, Box } from '@mui/material';

const ConfirmacaoToken: React.FC = () => {
  return (
    <div className="confirmacao-token-page">
      <Typography variant="h4" component="h1" gutterBottom>
        Confirmação de Token
      </Typography>
      <Box>
        <Typography variant="body1">
          Página de confirmação de token em desenvolvimento...
        </Typography>
      </Box>
    </div>
  );
};

export default ConfirmacaoToken; 